import React from 'react';

export default function ({ color = '#fff', size = 17 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.326762 5.87291C-0.108688 5.72776 -0.11213 5.49356 0.33572 5.34428L16.2409 0.0425567C16.6813 -0.104243 16.9339 0.142265 16.8105 0.574165L12.2661 16.4794C12.1403 16.9197 11.8865 16.935 11.7004 16.5164L8.70495 9.77671L13.705 3.11009L7.0383 8.11005L0.326762 5.87291Z"
        fill={color}
      />
    </svg>
  );
}
